import icon from 'vue-svgicon';

icon.register({
    'regular/image-file-landscape': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.477 21.75a1.5 1.5 0 0 1-1.5 1.5H3.023a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.047.426l2.955 2.883a1.5 1.5 0 0 1 .452 1.074z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="8.273" cy="7.5" r="2.25" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" d="M18.813 18.2l-3.925-5.888a1.011 1.011 0 0 0-1.671-.019l-2.691 3.845L8.858 14.8a1.011 1.011 0 0 0-1.474.229L5.273 18.2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
